const playBtnsOverlay = document.querySelectorAll('.js_reverse-media_content_media_overlay');
const txtMediaVideos = document.querySelectorAll('.js_reverse_media_content_media_video');

playBtnsOverlay.forEach((btn, index) => {
    btn.addEventListener('click', function() {
        const video = txtMediaVideos[index];
        const videoWrapper = video.parentElement;

        txtMediaVideos.forEach((video, videoIndex) => {
            if(index !== videoIndex) {
                video.parentElement.classList.remove('playing');
                video.pause();
            }
        })

        if (video.paused || video.ended) {
            videoWrapper.classList.add('playing');
            video.play();
        } else {
            videoWrapper.classList.remove('playing');
            video.pause();
        }
    })
})